import axios from "axios";
export const httpRulesEngineApim = axios.create({
    baseURL: process.env.REACT_APP_RULESENGINE_BASE_URL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF": "1",
    },
});
